<template>
  <div class="home">
    <swipeComponents></swipeComponents>
    <div class="btns">
      <van-button type="info" block to="sign">直播报名</van-button>
      <van-button type="info" block to="mysign">我的报名信息</van-button>
      <!-- <van-button type="info" block to="livepage">进入直播</van-button> -->
      <van-button type="info" block to="livelist">进入直播</van-button>
      <van-button type="info" block @click="gonggao">直播公告</van-button>
      <!-- <van-button type="info" block @click="goLookBack">视频回放</van-button> -->
    </div>
    <noticeBox></noticeBox>
  </div>
</template>

<script>
import { Button, Swipe, SwipeItem, ImagePreview } from "vant";
import swipeComponents from "@/components/swipe.vue";
import noticeBox from "@/components/Notice.vue";
export default {
  name: "Home",
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImagePreview.name]: ImagePreview,
    swipeComponents,
    noticeBox
  },
  methods: {
    gonggao() {
      this.$toast("最近无培训");
    },
    goLookBack() {
      window.location.href =
        "http://1300641169.vod2.myqcloud.com/68d063a9vodtranscq1300641169/f8ad24a35285890799143358897/v.f20.mp4";
    }
  }
};
</script>

<style lang="stylus" scoped>
.btns
  padding 15px
  .van-button
    margin-top 10px
</style>
